/* src/app/shared/components/ag-adjust-image/ag-adjust-image.component.scss */
:host {
  position: relative;
}
.rotation-buttons {
  display: flex;
  gap: 8px;
}
.bordered-image {
  height: fit-content;
  width: 100%;
  font-size: 0;
  position: relative;
  z-index: 4;
}
.bordered-image.crop-preview-widened {
  position: absolute;
  top: 0;
  left: 0;
  overflow: visible;
  text-align: center !important;
  background-color: #ffffff;
  z-index: 102;
}
.image-wrapper {
  position: relative;
  display: inline-block;
  pointer-events: auto;
}
.image-wrapper img {
  display: block;
  object-fit: cover;
  cursor: default;
  transition:
    width 0.3s ease,
    height 0.3s ease,
    object-fit 0.3s ease;
}
.image-wrapper img.transitioning-fit {
  transition:
    width 0.3s ease,
    height 0.3s ease,
    object-fit 0.3s ease,
    object-position 0.3s ease;
}
.image-wrapper img.fill-rotated-img {
  max-width: none;
  max-height: none;
}
.adjust-sidebar {
  position: fixed;
  z-index: 100;
  right: 0;
  bottom: 0;
  height: calc(100vh - 72px - 56px);
  width: 300px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  cursor: default;
  background-color: #ffffff;
}
.adjust-sidebar::-webkit-scrollbar {
  display: none;
}
.sidebar-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #dfdfdf;
  border-top: 1px solid #dfdfdf;
  padding: 8px 16px;
}
.sidebar-content {
  display: flex;
  flex-direction: column;
  padding: 16px;
  border-bottom: 1px solid #dfdfdf;
  gap: 12px;
}
.sidebar-hd {
  height: calc(100vh - 72px) !important;
  width: 300px !important;
}
.sidebar-hd-header {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 24px;
  margin-bottom: 12px;
}
.grey-input-wrapper {
  margin-top: 8px;
  width: 126px;
  height: 48px;
  border-radius: 12px;
  background: #f2f2f2;
  overflow: hidden;
  display: flex;
  flex-direction: row;
}
.grey-input-field {
  width: 90px;
  height: 48px;
  border-radius: 12px;
  background: transparent;
  border: none;
  padding-left: 16px;
}
.grey-input-field:focus-visible {
  outline: none;
}
.input-number-button-wrapper {
  border-left: 1px solid #dfdfdf;
  display: flex;
  flex-direction: column;
}
.input-number-button-wrapper .button-divider {
  height: 1px;
  width: 100%;
  background-color: #dfdfdf;
}
.input-number-field-buttons {
  width: 36px !important;
  height: 24px !important;
  background-color: transparent;
  border: none;
}
.input-number-field-buttons:hover {
  background-color: #ffffff;
  cursor: pointer;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance: textfield;
  appearance: textfield;
}
.fill-drag-tip {
  font-family: "Poppins-Regular";
  font-size: 12px;
  line-height: 16px;
  color: #5580dc;
  margin: 0;
  display: flex;
  align-items: center;
}
.fill-drag-tip img {
  width: 16px;
  height: 16px;
  vertical-align: middle;
  margin-right: 4px;
  filter: brightness(0) saturate(100%) invert(37%) sepia(84%) saturate(1186%) hue-rotate(199deg) brightness(101%) contrast(93%);
}
.padding-layout-container {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.crop-button {
  width: 84px !important;
  min-width: 84px !important;
  display: flex;
  padding: 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  justify-self: stretch;
  border-radius: 12px;
  background: #f2f2f2;
  border: 1px solid transparent;
  cursor: pointer;
}
.crop-button:hover {
  background: #ffffff;
  border: 1px solid #27272a;
}
.crop-button-active {
  background: #27272a !important;
  border: 1px solid #27272a !important;
}
.crop-button-active p {
  color: #ffffff !important;
}
.crop-button-active img {
  filter: brightness(0) invert(1);
}
.crop-flipped img {
  transform: rotate(-90deg);
}
.fill-scroll-info {
  position: absolute;
  top: 8px;
  right: 8px;
  padding: 2px;
  z-index: 6;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 6px;
  box-shadow: 0 2px 6px 2px rgba(0, 0, 0, 0.4);
  cursor: default;
}
.fill-scroll-info img {
  width: 20px;
  height: 20px;
  filter: brightness(0) saturate(100%) invert(37%) sepia(84%) saturate(1186%) hue-rotate(199deg) brightness(101%) contrast(93%);
}
.crop-box {
  position: absolute;
  z-index: 5;
  border: 2px dashed #5580dc;
  box-shadow: 0 4px 16px 4px rgba(0, 0, 0, 0.45);
  border-radius: 2px;
  box-sizing: border-box;
  cursor: move;
  overflow: visible;
}
.crop-box .crop-handle {
  position: absolute;
  background: #5580dc;
  border: 2px solid #5580dc;
  box-shadow: 0 2px 6px 2px rgba(0, 0, 0, 0.4);
  border-radius: 3px;
  box-sizing: border-box;
  z-index: 6;
}
.crop-box .crop-handle--top,
.crop-box .crop-handle--bottom {
  width: 12px;
  height: 12px;
  cursor: ns-resize;
  left: 50%;
  transform: translateX(-50%);
}
.crop-box .crop-handle--top {
  top: -7px;
}
.crop-box .crop-handle--bottom {
  bottom: -7px;
}
.crop-box .crop-handle--left,
.crop-box .crop-handle--right {
  height: 12px;
  width: 12px;
  cursor: ew-resize;
  top: 50%;
  transform: translateY(-50%);
}
.crop-box .crop-handle--left {
  left: -7px;
}
.crop-box .crop-handle--right {
  right: -7px;
}
.crop-box .crop-handle--topleft,
.crop-box .crop-handle--topright,
.crop-box .crop-handle--bottomleft,
.crop-box .crop-handle--bottomright {
  width: 12px;
  height: 12px;
}
.crop-box .crop-handle--topleft {
  top: -7px;
  left: -7px;
  cursor: nwse-resize;
}
.crop-box .crop-handle--topright {
  top: -7px;
  right: -7px;
  cursor: nesw-resize;
}
.crop-box .crop-handle--bottomleft {
  bottom: -7px;
  left: -7px;
  cursor: nesw-resize;
}
.crop-box .crop-handle--bottomright {
  bottom: -7px;
  right: -7px;
  cursor: nwse-resize;
}
.action-taskbar {
  display: flex;
  padding: 4px;
  align-items: center;
  gap: 4px;
  position: fixed;
  left: calc(50% - 5px);
  transform: translateX(-50%);
  z-index: 103;
  bottom: 24px;
  border-radius: 12px;
  border: 1px solid #dfdfdf;
  background: #ffffff;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05), 0 15px 25px 0 rgba(0, 0, 0, 0.07);
  cursor: default;
}
.action-taskbar-alert {
  border: 1px solid #e55e5e !important;
}
.action-toaster {
  display: flex;
  height: 32px;
  min-height: 32px;
  max-height: 32px;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  position: fixed;
  left: calc(50% - 5px);
  transform: translateX(-50%);
  transform-origin: 50% 50%;
  z-index: 103;
  bottom: 88px;
  border-radius: 8px;
  background: #e55e5e;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05), 0 15px 25px 0 rgba(0, 0, 0, 0.07);
}
.action-toaster p {
  color: #ffffff;
  font-size: 12px;
}
.action-toaster img {
  filter: brightness(0) invert(1);
  cursor: pointer;
}
.action-toaster--above-info {
  bottom: 128px;
}
@media (prefers-reduced-motion: no-preference) {
  .action-toaster.jiggle {
    animation: action-toaster-jiggle 320ms ease-out;
  }
}
@keyframes action-toaster-jiggle {
  0% {
    transform: translateX(-50%) rotate(0deg);
  }
  20% {
    transform: translateX(-50%) rotate(-3deg);
  }
  50% {
    transform: translateX(-50%) rotate(3deg);
  }
  80% {
    transform: translateX(-50%) rotate(-1.5deg);
  }
  100% {
    transform: translateX(-50%) rotate(0deg);
  }
}
.info-toaster {
  display: flex;
  height: 32px;
  min-height: 32px;
  max-height: 32px;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  position: fixed;
  left: calc(50% - 5px);
  transform: translateX(-50%);
  z-index: 103;
  bottom: 88px;
  border-radius: 8px;
  background: #5580dc;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05), 0 15px 25px 0 rgba(0, 0, 0, 0.07);
}
.info-toaster p {
  color: #ffffff;
  font-size: 12px;
}
/*# sourceMappingURL=ag-adjust-image.component.css.map */
